import React, { useEffect, useMemo } from "react";

import { Link } from "react-router-dom";
import Hoc from "../../../hoc/hoc";

function NavLinks(props) {
  const isActive = window.location.pathname === props.to;
  // const isActive = useMemo(() => {
  //   console.log(window.location.pathname, props.to);
  //   return window.location.pathname === props.to;
  // }, [window.location.pathname]);
  return props.display ? (
    <li className="nav-link">
      <Link
        to={props.to}
        style={{
          color: isActive ? "#02e9e6" : "white",
        }}
      >
        <span style={{ cursor: "pointer", textDecoration: "none" }}>
          {props.label}
        </span>
      </Link>
    </li>
  ) : (
    ""
  );
}

export default function CustomizedMenus(props) {
  const { permissions } = props;
  return (
    <Hoc>
      <div className="nav-btn" style={{}}>
        <li className="nav-links">
          <ul>
            <NavLinks
              display={
                !permissions ||
                (permissions &&
                  permissions.length &&
                  permissions.indexOf("training-list") >= 0)
              }
              to="/admin/trainings"
              label="प्रशिक्षण"
            />
            <NavLinks
              display={
                !permissions ||
                (permissions &&
                  permissions.length &&
                  permissions.indexOf("training-list") >= 0)
              }
              to="/admin/registrationTraining"
              label="प्रशिक्षण दर्ता"
            />
            <NavLinks
              display={
                !permissions ||
                (permissions &&
                  permissions.length &&
                  permissions.indexOf("trainee-approval") >= 0)
              }
              to="/admin/trainee-approval"
              label="प्रशिक्षार्थि स्वीकृति"
            />

            <NavLinks
              display={
                !permissions ||
                (permissions &&
                  permissions.length &&
                  permissions.indexOf("user-list") >= 0)
              }
              to="/admin/users"
              label="प्रयोगकर्ता प्रबन्धन"
            />
            <NavLinks
              display={
                !permissions ||
                (permissions &&
                  permissions.length &&
                  permissions.indexOf("report-list") >= 0)
              }
              to="/admin/report"
              label="रिपोर्ट"
            />
            <NavLinks
              display={
                !permissions ||
                (permissions &&
                  permissions.length &&
                  permissions.indexOf("role-list") >= 0)
              }
              to="/admin/roles"
              label="भूमिका प्रबन्धन"
            />
            {/* <NavLinks
              display={
                !permissions ||
                (permissions &&
                  permissions.length &&
                  permissions.indexOf("setting-list") >= 0)
              }
              to="/admin/Setting"
              label="सेटिंग्स"
            /> */}
            <NavLinks
              display
              to="/admin/setting/generalSetting"
              label="सेटिंग्स"
            />
          </ul>
        </li>
      </div>
    </Hoc>
  );
}
